// src/components/PointsBadge.js
import React from 'react';

const PointsBadge = ({ points, showPoints = false, size = 'md' }) => {
  const getBadgeInfo = (points) => {
    if (points >= 1000000) return { name: 'Legendary Steward', color: 'bg-purple-600' };
    if (points >= 100000) return { name: 'Guardian', color: 'bg-red-600' };
    if (points >= 1000) return { name: 'Harvester', color: 'bg-yellow-600' };
    if (points >= 100) return { name: 'Cultivator', color: 'bg-green-600' };
    if (points >= 1) return { name: 'Sprout', color: 'bg-emerald-600' };
    return { name: 'Seedling', color: 'bg-gray-600' };
  };

  const sizeClasses = {
    sm: 'text-xs px-2 py-1',
    md: 'text-sm px-3 py-1',
    lg: 'text-base px-4 py-2'
  };

  const { name, color } = getBadgeInfo(points);

  return (
    <div className={`inline-flex items-center rounded-full ${color} ${sizeClasses[size]} text-white font-medium`}>
      <span>{name}</span>
      {showPoints && <span className="ml-2">({points} pts)</span>}
    </div>
  );
};

export default PointsBadge;